import React from 'react';
import { Panel, PanelTheme, PanelBorderRadius, PanelBorderStyle } from '@apply/components';
import { AuthorizedDrawUserDto } from '@apply/api/src/api/ApplyApi';
import { ActionsButton } from './components/ActionsButton/ActionsButton';
import { StatusIndicator } from './components/StatusIndicator';
import { GeneralContractorRole } from './components/GeneralContractorRole';
import { GCUserLink } from './components/GCUserLink';
import { EmailLink } from './components/EmailLink';
import { Phone } from './components/Phone';
import { GCStatusType } from '@apply/constants';

export interface ByUserMobilePanelProps {
    user: AuthorizedDrawUserDto;
    onRefresh: () => void;
}

export const ByUserMobilePanel: React.FC<ByUserMobilePanelProps> = ({ user, onRefresh }) => {
    let status: GCStatusType;

    // 1) 'Invited' - Has AuthorizedDrawUser record, but has not yet registered their account
    if (user.needsPasswordReset) {
        status = GCStatusType.Invited;
    }
    // 2) 'Needs Project' - has registered account but not assigned to any properties
    else if (!user.hasPropertyAssignment) {
        status = GCStatusType.NeedsProject;
    }
    // 3) 'Pending GC' - registered and assigned to properties, but not yet accepted
    else if (!user.gcAcceptedUtc) {
        status = GCStatusType.Pending;
    }
    // 4) 'Activated' - meets all criteria
    else {
        status = GCStatusType.Activated;
    }

    return (
        <>
            <Panel
                theme={PanelTheme.White}
                borderRadius={PanelBorderRadius.Medium}
                borderStyle={PanelBorderStyle.Solid}
            >
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', paddingBottom: '20px' }}>
                        <div
                            style={{
                                flex: 1,
                                overflow: 'wrap',
                                overflowWrap: 'break-word',
                                paddingRight: '5px',
                            }}
                        >
                            <GCUserLink
                                authorizedDrawUserId={user.id}
                                firstName={user.displayFirstName || ''}
                                lastName={user.displayLastName || ''}
                                onRefresh={onRefresh}
                            />
                            <GeneralContractorRole role={user.displayRole} />
                        </div>
                        <div style={{ width: 'auto' }}>
                            <StatusIndicator status={status} />
                            <div className='manageUsersByUserTable-generalContractor-projects-mobile'>
                                Projects: {user.projectCount}
                            </div>
                        </div>
                    </div>
                    <div style={{ overflow: 'wrap', overflowWrap: 'anywhere' }}>
                        <Phone phoneNumber={user.displayPhone || ''} />
                        <EmailLink emailAddress={user.email || ''} />
                        <br />
                        <ActionsButton user={user} onRefresh={onRefresh} />
                    </div>
                </div>
            </Panel>
        </>
    );
};
